import _ from 'lodash';
import * as consts from '../../constants';
import { containsObject } from '../../shared/utility';
import authenticationApi from '../../api/authenticationApi';
import MarketplacesApi from '../../api/MarketplacesApi';
import Axios from 'axios';

// Add a 401 response interceptor
Axios.interceptors.response.use(function (response) {
   // console.log("intercept response", response);
   return response;
}, function (error) {
   // console.log("intercept response error", error);
   if (401 === error.response.status) {
      console.log("Intercept response error 401", error);
      setSession(null);
      window.location = '/login';
   } else {
      return Promise.reject(error.response.data);
   }
});
/**
 *
 * @param userData
 * @returns {function(*): Promise<unknown>}
 */
export function login(userData) {
   return dispatch => {

      return authenticationApi.login(userData)
         .then(response => {
            if (response.success === true) {
               dispatch(loadUserConfiguration(response.data));
               dispatch(authSuccess(response.data));
               // return response.data;
            }
            else {
               setSession(null);
               console.log('Invalid credentials provided');
               throw new Error('Invalid credentials provided');
            }
         })
         .catch(error => {
            console.log('Login fail');
            throw error;
         });
   };
}

const setSession = authData => {
   if (authData) {
      localStorage.setItem('authData', JSON.stringify(authData));
      Axios.defaults.headers.common['Authorization'] = 'Bearer ' + authData.access_token;
   }
   else {
      localStorage.removeItem('authData');
      delete Axios.defaults.headers.common['Authorization'];
   }
};

const loadUserConfiguration = (authData) => {
   setSession(authData);
   return function (dispatch) {
      dispatch(loadMarketplacesLanguages());
   }
}

const deleteUserConfiguration = () => {
   console.log('User logout');
   return authenticationApi.logout()
      .then(response => {
         setSession(null);
         console.log('Backend logout');
      })
      .catch(error => {
         setSession(null);
         throw error;
      });
}

const loadMarketplacesLanguages = () => {
   return dispatch => {
      return MarketplacesApi.getList()
      .then(response => {
         console.log(response);
            if (response.data.success === true) {
               let aux = {};
               let languages = [];
               response.data.data.forEach(el => {
                  aux = {};
                  aux.label = el.language.code;
                  aux.value = el.language.id;
                  if( !containsObject(aux, languages, 'value') ) {
                     languages.push(aux);
                  }
               });
               dispatch(loadMarketplacesLanguagesSuccess(languages));
               // return response.data;
            }
            else {
               throw new Error('Client error');
            }
         })
         .catch(error => {
            dispatch(systemFatalError(consts.ERROR_CODES.HTTP.USER_CONFIGURATION_LOADING));
            // throw error;
         });
   }
}

function loadMarketplacesLanguagesSuccess(languages) {
   return { type: consts.ACTIONS.LOAD_MARKETPLACES_LANGUAGES_SUCCESS, languages };
}


/**
 *
 * @param authData
 * @returns {{authData: *, type: *}}
 */
export const authSuccess = (authData) => {
   return {
      type: consts.ACTIONS.AUTH_SUCCESS,
      payload: authData
   };
};

export const authFail = (error) => {
   return {
      type: consts.ACTIONS.AUTH_FAIL,
      error: error
   };
};

export const logout = () => {
   deleteUserConfiguration();
   return {
      type: consts.ACTIONS.AUTH_LOGOUT
   };
};

export const authCheckState = () => {
   console.log('Check authentication');
   return dispatch => {
      const authData = JSON.parse(localStorage.getItem('authData'));
      // console.log(authData);
      if (authData && authData.access_token) {
         //CHECK TOKEN EXPIRATION DATE
         // const expirationDate = new Date(authData.expirationDate);
         // if (expirationDate <= new Date()) {
         //     dispatch(logout());
         // } else {
         //     dispatch(authSuccess(authData));
         //     // dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ));
         // }
         //IF EXPIRED REFRESH TOKEN
         //TODO: PURGE EXPIRED TOKENS
         dispatch(loadUserConfiguration(authData));
         dispatch(authSuccess(authData));
      }
      else {
         setSession(null);
      }
   };
};

/**
 *
 * @param errorCode
 * @param error
 * @returns {{errorCode: *, type: *}}
 */
export function systemFatalError(errorCode, error) {

   if (_.toNumber(error) > 0) {
      return { type: consts.ACTIONS.SYSTEM_FATAL_ERROR, errorCode: _.toNumber(error) };
   }
   else {
      return { type: consts.ACTIONS.SYSTEM_FATAL_ERROR, errorCode: errorCode };
   }
}